<div class="form-group">
    <p-toggleswitch
        [inputId]="id() + '-toggle-switch'"
        [(ngModel)]="value"
        [required]="required()"
        [disabled]="disabled()"
        (onChange)="onChange.emit($event)">
    </p-toggleswitch>

    @if (label()) {
        <form-label
            [id]="id() + '-label'"
            [forId]="id() + '-toggle-switch'"
            [label]="label()"
            [required]="required()"
            [tooltipText]="tooltipText()"></form-label>
    }
</div>
